import { useEffect } from 'react';

import { getCatalogPageQuery } from '@/lib/shared/lib/listing-page-query';

import { clsx } from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './Pagination.module.scss';

import { ArrowIcon } from '../../icons';
import { CircleButton } from '../Buttons';

interface IPagination {
  currentPage: number;
  maxPages: number;
  setNext: () => void;
  setPrev: () => void;
  jumpToPage: (arg: number) => void;
  className?: string;
}
const getPagesArr = (pagesAmount: number) => {
  const result = [];
  for (let i = 1; i <= pagesAmount; i++) {
    result.push(i);
  }
  return result;
};
export const Pagination = ({
  currentPage,
  jumpToPage,
  maxPages,
  className,
}: IPagination) => {
  const router = useRouter();
  const pagesArr = getPagesArr(maxPages);
  const showFirstDots = currentPage > 4;
  const showLastDots = currentPage + 3 < maxPages;

  useEffect(() => {
    if (currentPage > maxPages && currentPage !== 1) {
      jumpToPage(maxPages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, maxPages]);
  return (
    <div className={clsx(styles.pagination, className)}>
      <CircleButton
        as={Link}
        href={{
          pathname: router.pathname,
          query: getCatalogPageQuery(router.query, currentPage - 1),
        }}
        shallow
        content={<ArrowIcon />}
        styleType={'secondary'}
        theme={'dark'}
        className={styles.pagination__arrow}
        disabled={currentPage === 1}
        name="select previous page"
      />
      {currentPage > 3 && (
        <Link
          className={clsx(
            styles.pagination__button,
            currentPage === 1 && styles['pagination__button--active']
          )}
          shallow
          href={{
            pathname: router.pathname,
            query: getCatalogPageQuery(router.query, 1),
          }}
        >
          1
        </Link>
      )}

      {showFirstDots && <DotsButton />}
      {pagesArr
        .slice(Math.max(0, currentPage - 3), currentPage + 2)
        .map((page) => {
          const isActive = page === currentPage;
          return (
            <Link
              key={page}
              className={clsx(
                styles.pagination__button,
                isActive && styles['pagination__button--active']
              )}
              shallow
              href={{
                pathname: router.pathname,
                query: getCatalogPageQuery(router.query, page),
              }}
            >
              {page}
            </Link>
          );
        })}
      {showLastDots && <DotsButton />}
      {maxPages - currentPage > 2 && (
        <Link
          className={clsx(
            styles.pagination__button,
            currentPage === maxPages && styles['pagination__button--active']
          )}
          shallow
          href={{
            pathname: router.pathname,
            query: getCatalogPageQuery(router.query, maxPages),
          }}
        >
          {maxPages}
        </Link>
      )}
      <CircleButton
        name="select next page"
        as={Link}
        content={<ArrowIcon isRight />}
        styleType={'secondary'}
        theme={'dark'}
        shallow
        className={styles.pagination__arrow}
        href={{
          pathname: router.pathname,
          query: getCatalogPageQuery(router.query, currentPage + 1),
        }}
        disabled={currentPage === maxPages}
      />
    </div>
  );
};

const DotsButton = () => {
  return (
    <button className={clsx(styles.pagination__arrow, styles.pagination__dots)}>
      ...
    </button>
  );
};
